import { Route, Routes } from "react-router-dom";
import { useMatomoTracking } from "@/hooks/useMatomoTracking";
import LandingPage from "@/pages/Landing";
import MethodologiePage from "@/pages/Methodologie";
import CguPage from "@/pages/legal/Cgu";
import MentionsLegalesPage from "@/pages/legal/MentionsLegales";
import ConfidentialitePage from "@/pages/legal/Confidentialite";
import CookiesPage from "@/pages/legal/Cookies";
import LoginPage from "@/pages/Login";
import RegisterPage from "@/pages/Register";
import VerifyEmailPage from "@/pages/VerifyEmail";
import PasswordResetPage from "@/pages/PasswordReset";
import DashboardPage from "@/pages/Dashboard";
import AccountPage from "@/pages/Account";
import LogementNewPage from "@/pages/LogementNew";
import LogementDetailPage from "@/pages/LogementDetail";
import LogementDPEPage from "@/pages/LogementDPE";
import LogementResultatPage from "@/pages/LogementResultat";
import AdminPage from "@/pages/Admin";
import AdminUsersPage from "@/pages/AdminUsers";
import AdminHealthPage from "@/pages/AdminHealth";
import AdminEnginePage from "@/pages/AdminEngine";
import AdminFlagsPage from "@/pages/AdminFlags";
import AdminAffiliationsPage from "@/pages/AdminAffiliations";
import AdminRoiPage from "@/pages/AdminRoi";
import AdminEnergyPricesPage from "@/pages/AdminEnergyPrices";
import AdminHomeVariantPage from "@/pages/AdminHomeVariant";
import AdminScenariosPanelVariantPage from "@/pages/AdminScenariosPanelVariant";
import AdminRenovationObjectivesPage from "@/pages/AdminRenovationObjectives";
import NotFoundPage from "@/pages/NotFound";
import { RequireAuth } from "@/components/RequireAuth";
import { RequireAdmin } from "@/components/RequireAdmin";
import { RequireGuest } from "@/components/RequireGuest";

export default function App() {
  useMatomoTracking();

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />

      {/* Page publique : méthodologie du moteur DPE */}
      <Route path="/methodologie" element={<MethodologiePage />} />

      {/* Pages légales publiques */}
      <Route path="/cgu" element={<CguPage />} />
      <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
      <Route path="/confidentialite" element={<ConfidentialitePage />} />
      <Route path="/cookies" element={<CookiesPage />} />

      {/* Pages réservées aux non-connectés */}
      <Route
        path="/login"
        element={
          <RequireGuest>
            <LoginPage />
          </RequireGuest>
        }
      />
      <Route
        path="/register"
        element={
          <RequireGuest>
            <RegisterPage />
          </RequireGuest>
        }
      />

      {/* Page accessible aux deux : avec ou sans token */}
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/password-reset" element={<PasswordResetPage />} />

      {/* Pages réservées aux utilisateurs connectés et email vérifié */}
      <Route
        path="/dashboard"
        element={
          <RequireAuth>
            <DashboardPage />
          </RequireAuth>
        }
      />
      <Route
        path="/account"
        element={
          <RequireAuth>
            <AccountPage />
          </RequireAuth>
        }
      />
      <Route
        path="/logements/new"
        element={
          <RequireAuth>
            <LogementNewPage />
          </RequireAuth>
        }
      />
      <Route
        path="/logements/:id"
        element={
          <RequireAuth>
            <LogementDetailPage />
          </RequireAuth>
        }
      />
      <Route
        path="/logements/:id/dpe"
        element={
          <RequireAuth>
            <LogementDPEPage />
          </RequireAuth>
        }
      />
      <Route
        path="/logements/:id/resultat"
        element={
          <RequireAuth>
            <LogementResultatPage />
          </RequireAuth>
        }
      />

      <Route
        path="/admin"
        element={
          <RequireAdmin>
            <AdminPage />
          </RequireAdmin>
        }
      />
      <Route
        path="/admin/users"
        element={
          <RequireAdmin>
            <AdminUsersPage />
          </RequireAdmin>
        }
      />
      <Route
        path="/admin/health"
        element={
          <RequireAdmin>
            <AdminHealthPage />
          </RequireAdmin>
        }
      />
      <Route
        path="/admin/engine"
        element={
          <RequireAdmin>
            <AdminEnginePage />
          </RequireAdmin>
        }
      />
      <Route
        path="/admin/flags"
        element={
          <RequireAdmin>
            <AdminFlagsPage />
          </RequireAdmin>
        }
      />
      <Route
        path="/admin/affiliations"
        element={
          <RequireAdmin>
            <AdminAffiliationsPage />
          </RequireAdmin>
        }
      />
      <Route
        path="/admin/roi"
        element={
          <RequireAdmin>
            <AdminRoiPage />
          </RequireAdmin>
        }
      />
      <Route
        path="/admin/energy-prices"
        element={
          <RequireAdmin>
            <AdminEnergyPricesPage />
          </RequireAdmin>
        }
      />
      <Route
        path="/admin/home-variant"
        element={
          <RequireAdmin>
            <AdminHomeVariantPage />
          </RequireAdmin>
        }
      />
      <Route
        path="/admin/scenarios-variant"
        element={
          <RequireAdmin>
            <AdminScenariosPanelVariantPage />
          </RequireAdmin>
        }
      />
      <Route
        path="/admin/renovation-objectives"
        element={
          <RequireAdmin>
            <AdminRenovationObjectivesPage />
          </RequireAdmin>
        }
      />

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
